import setFieldValue from "@bevco/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@bevco/Store/Reducers";
import { OwnProps, setRequestFormEffects, validateFieldBy } from "@bevco/Widgets/CreateAccount/FormBaseComponent";
import { getCountriesDataView } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import translate from "@insite/client-framework/Translate";
import { CountryModel } from "@insite/client-framework/Types/ApiModels";
import Select from "@insite/mobius/Select";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => {
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);

    return {
        billingCountry: state.customCreateAccountForm.fieldValues.billingCountry,
        previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
        countries: countriesDataView.value,
        shouldLoadCountries: !countriesDataView.value && !countriesDataView.isLoading,
    };
};

const mapDispatchToProps = {
    setFieldValue,
    loadCurrentCountries,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const BillingCountryWidget: React.FC<Props> = ({
    billingCountry,
    countries,
    setFieldValue: widgetSetFieldValue,
    loadCurrentCountries,
    shouldLoadCountries,
}) => {
    const label = translate("Country");
    const isRequired = true;
    const hintText = "Select";
    const [billingCountryOptions, setbillingCountryOptions] = React.useState<{ label: any; value: any }[]>([]);
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, billingCountry, "billingCountry", () =>
        validateFieldBy(isRequired, label, billingCountry, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        widgetSetFieldValue({ key: "billingCountry", value: event.target.value });
    };

    const getbillingCountryOptions = () => {
        setbillingCountryOptions(countries?.map?.((x: any) => ({ label: x.name, value: x.name })) || []);
    };

    React.useEffect(() => {
        if (shouldLoadCountries) {
            loadCurrentCountries();
        }
    }, [shouldLoadCountries]);

    React.useEffect(() => {
        getbillingCountryOptions();
    }, [countries]);

    return (
        <Select
            label={label}
            required={isRequired}
            value={billingCountry || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            placeholder={hintText || ""}
        >
            <option value="" {...(isRequired && { disabled: true })}>
                {translate(hintText)}
            </option>
            {countries?.map((billingCountry: CountryModel) => (
                <option key={billingCountry.id} value={billingCountry.name}>
                    {billingCountry.name}
                </option>
            ))}
        </Select>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingCountryWidget);
